import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { EMPTY_OBJECT, AjaxContext, AppContext } from 'commons-ui';
import * as dashboardModel from '../../utils/model';

const useCreate = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();

	const handleFormSubmit = async (submittedData: dashboardModel.IRewardCoinsUtil) => {
		try {
			const result: { data: dashboardModel.RESPONSE } = await postData({
				endpoint: '/marketing/dashboard/cashbackUtil/editCashbackSegments',
				queryParams: {
					appName
				},
				body: {
					segmentName: submittedData?.segmentName,
					cashbackUtil: submittedData?.cashbackUtil,
					bonusUtil: submittedData?.bonusUtil
				}
			});
			if (!result?.data?.success) throw Error('Error in creating the config!');
			return;
		} catch (error) {
			showAlert('Error in creating the config', { type: 'error' });
			throw error;
		} finally {
			history.goBack();
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
